// extracted by mini-css-extract-plugin
module.exports = {"sidebarButton":"_3N1lB","collapsed":"_3pxYe"};